import { Link } from "core/link"
import React from "react"

/**
 * FreeOverLimitBanner displays when a free account has reached its subscriber limit.
 *
 * IF THIS COMPONENT IS UPDATED, UPDATE THE RAILS PARTIAL AT app/views/layouts/_free_over_limit.html.erb
 *
 * @param {number} activeSubscriberCount - Current number of active subscribers
 * @param {number} subscriberLimit - The account's subscriber limit
 */
export function FreeOverLimitBanner({
  activeSubscriberCount,
  subscriberLimit
}) {
  return (
    <div className="alert-no-hide alert-warning alert--banner alert--account-review">
      Congrats! Your account is growing and you&apos;ve reached your subscriber
      limit ({activeSubscriberCount.toLocaleString()} out of{" "}
      {subscriberLimit.toLocaleString()}).
      <br />
      Enable email sending again by{" "}
      <strong>
        <Link href="/account/upgrade">upgrading your account</Link>
      </strong>
      .
    </div>
  )
}
